import TelemetryService from "./telemetryService";
import TelemetryDatadogRUM from "./providers/telemetryDatadogRUM";

const createTelemetryService = (properties = {}) => {
  // Set Initial Properties with Service & Env
  const { datadogRUMConfig } = window.telemetryConfig;
  
  const newProperties = {
    ...properties,
    service: datadogRUMConfig.DD_SERVICE
      ? datadogRUMConfig.DD_SERVICE.toLowerCase()
      : "",
    env: datadogRUMConfig.DD_ENV ? datadogRUMConfig.DD_ENV : "",
  };

  // Create Instance
  const telemetryService = new TelemetryService(
    [new TelemetryDatadogRUM()],
    newProperties
  );

  return telemetryService;
};

export default createTelemetryService;



// WEBPACK FOOTER //
// ./client/src/telemetry/telemetryInit.js